$('.video-reviews').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.video-previews',
  responsive: [
    {
      breakpoint: 768,
      settings: 'unslick',
    },
  ],
});
$('.video-previews').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.video-reviews',
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 768,
      settings: 'unslick',
    },
  ],
});



// WEBPACK FOOTER //
// ./scripts/blocks/video-review.js